import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';

const RESET_BUTTON_SELECTOR = '.js-selected-contact-summary__reset';

/**
 * SelectedContactSummary Component
 * Displays a summary card of the selected contact with name, membership info,
 * and an option to change the selection. Designed to be used as a form question type.
 */
class SelectedContactSummary extends FormComponent {
	constructor(containerElement, config) {
		super(containerElement, config);
		this._onResetCallback = null;
	}

	getContactData(data = this.data) {
		if (typeof data?.getSelectedContact === 'function') {
			return data.getSelectedContact() || {};
		}

		return data?.contactData || {};
	}

	markup(value, data = {}, titleMarkup) {
		const contactData = this.getContactData(data);
		const { displayName, membershipNumber } = contactData;

		// If no contact is selected, render nothing
		if (!displayName) {
			return '';
		}

		return `
			<div class="lta-selected-contact-summary">
				<div class="lta-selected-contact-summary__content">
					<div class="lta-selected-contact-summary__content-name u-h6">${displayName}</div>
					${membershipNumber ? `<div class="lta-selected-contact-summary__email u-body2 u-mt-1">${membershipNumber}</div>` : ''}
				</div>
				<button 
					type="button" 
					class="lta-selected-contact-summary__reset js-selected-contact-summary__reset u-mt-2"
					aria-label="Change selected contact"
				>
					Select a different contact
				</button>
			</div>
		`;
	}

	afterRender() {
		const resetButton = SelectorEngine.findOne(RESET_BUTTON_SELECTOR, this._element);

		if (resetButton) {
			EventHandler.on(resetButton, 'click', () => {
				if (this._onResetCallback) {
					this._onResetCallback();
				}

				// Emit custom event for external listeners
				this._element.dispatchEvent(
					new CustomEvent('selectedContactReset', {
						detail: { component: this },
						bubbles: true,
						cancelable: true
					})
				);
			});
		}
	}

	/**
	 * Register callback to be called when reset button is clicked
	 * @param {Function} callback
	 */
	onReset(callback) {
		this._onResetCallback = callback;
	}
}

export default SelectedContactSummary;
